import e, { useRef as b } from "react";
import { c as r, t as i } from "./useKeyDown-88662051.mjs";
import { I as k, a as B } from "./Image-be3826ec.mjs";
import { V as W } from "./Video-83c15c06.mjs";
import { W as E } from "./Icon-e01b6482.mjs";
import { B as q } from "./Button-eec2778c.mjs";
import { B as g } from "./useClickOutside-55c64a80.mjs";
import "./ImageContext-57256dc1.mjs";
import "./app-51178863.mjs";
const y = "hero-ratio", P = "article__hero-container", I = "desktop", w = "hero-ratio-without-quote", A = "article__hero-container--without-quote", D = "article__header", F = "article__header__no-buttons", G = "article__save-button", M = "article__save-button__svg", O = "button__icon", V = "article__hero-container__wrapper", j = "article__hero-container__wrapper__reference", z = "article__hero-container__wrapper__reference__text", J = "article__hero-container__no-sibling", K = "article__quote", U = "article__quote__light", X = "article__quote__text__dark__title", Y = "article__quote__text__light__title", Z = "article__quote__text__light__source", $ = "article__quote__text__light__ranking", ee = "article__leadText", te = "article__description", t = {
  heroRatio: y,
  articleHeroContainer: P,
  desktop: I,
  heroRatioWithoutQuote: w,
  articleHeroContainerWithoutQuote: A,
  articleHeader: D,
  articleHeaderNoButtons: F,
  articleSaveButton: G,
  articleSaveButtonSvg: M,
  buttonIcon: O,
  articleHeroContainerWrapper: V,
  articleHeroContainerWrapperReference: j,
  articleHeroContainerWrapperReferenceText: z,
  articleHeroContainerNoSibling: J,
  articleQuote: K,
  articleQuoteLight: U,
  articleQuoteTextDarkTitle: X,
  articleQuoteTextLightTitle: Y,
  articleQuoteTextLightSource: Z,
  articleQuoteTextLightRanking: $,
  articleLeadText: ee,
  articleDescription: te
};
function f(l) {
  const {
    quote: { field: s, title: c, source: _, ranking: h }
  } = l, a = s === "light", o = r(
    t.articleQuote,
    a && t.articleQuoteLight
  ), p = r({
    [i.textsLeadTextBold]: a,
    [t.articleQuoteTextLightTitle]: a,
    // Override light mode styling and typography with dark mode
    [i.textsLeadText]: !a,
    [t.articleQuoteTextDarkTitle]: !a
  });
  let d = "", m = "";
  return a && (d = r(
    i.textsLeadText,
    t.articleQuoteTextLightSource
  ), m = r(
    i.textsLeadTextBold,
    t.articleQuoteTextLightRanking
  )), /* @__PURE__ */ e.createElement(
    "div",
    {
      className: o,
      "data-testid": "article-page-hero-quote-container"
    },
    a ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("p", { className: m }, "#", h), /* @__PURE__ */ e.createElement("p", { className: p, itemProp: "description" }, c), /* @__PURE__ */ e.createElement("p", { className: d }, _)) : /* @__PURE__ */ e.createElement("p", { className: p, itemProp: "description" }, c)
  );
}
function ae({ isSaved: l = !1, onClick: s }) {
  const c = l ? E.HEART_FILLED : E.HEART;
  return /* @__PURE__ */ e.createElement(
    q.IconLabel,
    {
      text: "Save",
      onClick: s,
      icon: {
        type: c,
        size: 16,
        className: t.articleSaveButtonSvg
      }
    }
  );
}
function _e(l) {
  const {
    assetType: s,
    heading: c,
    leadText: _,
    heroSource: h,
    imageReference: a,
    quote: o,
    isSaved: p,
    onSave: d,
    hasIcons: m,
    description: x
  } = l, { displaySource: n, altText: C, mimeType: L, credits: N } = h, T = b(null), H = r(
    i.headingPage,
    t.articleHeader,
    m ? "" : t.articleHeaderNoButtons
  ), S = r(t.articleHeroContainer, {
    [t.articleHeroContainerWithoutQuote]: !o,
    [t.articleHeroContainerNoSibling]: !(T.current && T.current.nextElementSibling)
  }), v = r(
    i.textsCaption,
    t.articleHeroContainerWrapperReferenceText
  ), Q = r(
    i.textsComponentTitleBold,
    t.articleLeadText
  ), R = r(
    i.textsLeadText,
    t.articleDescription
  ), u = typeof n != "string";
  return /* @__PURE__ */ e.createElement("div", { className: "article", "data-testid": "article-page" }, /* @__PURE__ */ e.createElement(
    g,
    {
      topPadding: g.Padding.SMALL,
      bottomPadding: g.Padding.LARGE,
      "data-testid": "article-page-block"
    },
    /* @__PURE__ */ e.createElement(
      g.Content,
      {
        "data-testid": "article-page-block-content",
        itemScope: !0,
        itemType: "https://schema.org/Thing"
      },
      /* @__PURE__ */ e.createElement("h1", { className: H, itemProp: "name" }, c),
      m && /* @__PURE__ */ e.createElement(
        "div",
        {
          className: t.articleSaveButton,
          "data-testid": "article-page-save-button"
        },
        /* @__PURE__ */ e.createElement(ae, { onClick: d, isSaved: p })
      ),
      /* @__PURE__ */ e.createElement(
        "div",
        {
          className: S,
          ref: T,
          itemScope: !0,
          itemType: "https://schema.org/ImageObject"
        },
        s === "image" ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("div", { className: t.articleHeroContainerWrapper }, /* @__PURE__ */ e.createElement(
          k,
          {
            src: u ? n.imageSrc : "",
            width: u ? n.width : 0,
            height: u ? n.height : 0,
            altText: C,
            imageLoader: u ? n.imageLoader : () => "",
            styling: B.ARTICLE_PAGE_HERO,
            "data-testid": "article-page-image",
            credits: N
          }
        ), a && /* @__PURE__ */ e.createElement(
          "div",
          {
            className: t.articleHeroContainerWrapperReference,
            "data-testid": "article-hero-image-reference"
          },
          /* @__PURE__ */ e.createElement(
            "p",
            {
              className: v,
              itemProp: "citation"
            },
            a
          )
        )), o && /* @__PURE__ */ e.createElement(f, { quote: o })) : /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
          W,
          {
            title: C,
            autoplay: !0,
            videoType: "asset",
            video: {
              src: u ? "" : n,
              mimeType: L
            },
            "data-testid": "article-page-video"
          }
        ), o && /* @__PURE__ */ e.createElement(f, { quote: o }))
      ),
      _ && /* @__PURE__ */ e.createElement("p", { className: Q, itemProp: "description" }, _),
      x && /* @__PURE__ */ e.createElement(
        "div",
        {
          className: r(i.richText, R),
          itemProp: "description"
        },
        x
      )
    )
  ));
}
export {
  _e as ArticlePageHero,
  ae as SaveButton
};
//# sourceMappingURL=ArticlePageHero.js.map
